import React, { useEffect, useState } from 'react';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/sections/Footer';
import api from '../../lib/api';
import { LEGAL_DEFAULTS } from '../../lib/legalDefaults';

export const LegalLayout = ({ kicker, title, children }) => (
  <div className="min-h-screen bg-[#FFFFFF] text-[#111111]">
    <div className="fixed top-0 left-0 w-full z-50">
      <Navbar />
    </div>
    <main className="pt-40 pb-32">
      <div className="container-custom max-w-3xl">
        <div className="mb-16">
          <span className="text-xs uppercase tracking-[0.4em] text-[#111111] mb-6 block" data-testid="legal-kicker">{kicker}</span>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-serif text-[#111111] leading-[1.05] break-words hyphens-auto" data-testid="legal-title">{title}</h1>
          <div className="w-24 h-[1px] bg-[#111111] mt-10"></div>
        </div>
        <div className="prose-jbmh space-y-8 text-[#333333] text-lg font-light leading-relaxed">
          {children}
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export const Block = ({ title, children }) => (
  <section>
    <h2 className="text-xs uppercase tracking-[0.3em] text-[#111111] mb-4">{title}</h2>
    <div className="text-[#333333] leading-relaxed space-y-4">{children}</div>
  </section>
);

const EMAIL_RE = /([\w.+-]+@[\w-]+\.[\w.-]+\w)/g;
const linkify = (line) => line.split(EMAIL_RE).map((part, i) => (i % 2
  ? <a key={i} href={`mailto:${part}`} className="text-[#111111] hover:underline">{part}</a>
  : part));

// Paragraphs are separated by a blank line; lines starting with "- " become a list.
const runs = (lines) => lines.reduce((acc, l) => {
  const list = l.startsWith('- ');
  const last = acc[acc.length - 1];
  if (last && last.list === list) last.lines.push(l); else acc.push({ list, lines: [l] });
  return acc;
}, []);
const Body = ({ text }) => text.split(/\n\s*\n/).flatMap((para, i) => runs(para.split('\n')).map((r, k) => (r.list
  ? <ul key={`${i}-${k}`} className="list-disc pl-6 space-y-2">{r.lines.map((l, j) => <li key={j}>{linkify(l.slice(2))}</li>)}</ul>
  : <p key={`${i}-${k}`}>{r.lines.map((l, j) => <React.Fragment key={j}>{j > 0 && <br />}{linkify(l)}</React.Fragment>)}</p>)));

export const LegalPage = ({ pageKey }) => {
  const [page, setPage] = useState(null);
  useEffect(() => {
    api.get(`/legal/${pageKey}`).then(({ data }) => setPage(data?.title ? data : LEGAL_DEFAULTS[pageKey])).catch(() => setPage(LEGAL_DEFAULTS[pageKey]));
  }, [pageKey]);
  if (!page) return <LegalLayout kicker="" title="" />;
  return (
    <LegalLayout kicker={page.kicker} title={page.title}>
      {page.blocks.map((b, i) => (
        <div key={i} data-testid={`legal-block-${i}`}>
          <Block title={b.title}><Body text={b.body} /></Block>
        </div>
      ))}
    </LegalLayout>
  );
};
